import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { makeStyles } from '@material-ui/core/styles';
import { BaSeIcon } from '@base/react';
import { SwiperImg } from '../../../../components/SwiperImg';
import { cnpjMask, numberToPorcent } from '../../../../utils/mask';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { FiCamera } from 'react-icons/fi';
import { RiPencilLine } from 'react-icons/ri';

import styles from './styles.module.scss';

export function RenderActionsTooltip({ row, reportSelecionado }) {
  const value = row?.devolutiva?.devolutiva ? row.devolutiva : row;
  const { percentualGeral, temas, classificacao } = value ?? {};
  const { descricao } = row ?? {};

  // const { showModal } = React.useContext(BaSeDialogContext);

  const [open, setOpen] = React.useState(false);
  const [rowSelectedToImg, setRowSelectedToImg] = React.useState({});

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenImg = (rowSelected) => {
    setRowSelectedToImg(rowSelected);
    setOpen(true);
  };

  const useStylesBootstrap = makeStyles(() => ({
    arrow: {
      color: '#00ccff',
    },
    tooltip: {
      backgroundColor: '#00ccff',
      width: '200px',
    },
  }));

  const useStylesBootstrapErroSas = makeStyles(() => ({
    arrow: {
      color: '#00ccff',
    },
    tooltip: {
      backgroundColor: '#00ccff',
      width: '400px',
      borderRadius: '15px',
    },
  }));

  const useStylesBootstrapEmpresas = makeStyles(() => ({
    arrow: {
      color: '#00ccff',
    },
    tooltip: {
      backgroundColor: '#00ccff',
    },
  }));

  const classesTooltip = useStylesBootstrap();
  const classesTooltipErroSas = useStylesBootstrapErroSas();
  const classesToolTipEmpresas = useStylesBootstrapEmpresas();

  return (
    <div style={{ display: 'flex', gap: '0.5rem' }}>
      {!!descricao && reportSelecionado === 'atendimentosSse' && (
        <Tooltip
          classes={classesTooltip}
          placement="top-start"
          arrow
          title={
            <React.Fragment>
              <div className={styles.tooltip_wrapper}>
                <h4>Orientação do Agente SSE</h4>
                <br></br>

                <h4>{descricao}</h4>
              </div>
            </React.Fragment>
          }
        >
          <span>
            <RiPencilLine size={20} color={'#00ccff'} />
          </span>
        </Tooltip>
      )}
      {!descricao && reportSelecionado === 'atendimentosSse' && (
        <span>
          <RiPencilLine size={20} color={'#8F90A6'} />
        </span>
      )}

      {reportSelecionado === 'atendimentosSse' &&
        (row?.imagens?.length ? (
          <div
            onClick={() => handleOpenImg(row?.imagens)}
            className={styles.img_button_active}
          >
            <Tooltip title="Exibir imagem">
              <div>
                <FiCamera size={20} color="#00ccff" />
              </div>
            </Tooltip>
          </div>
        ) : (
          <div className={styles.img_button_desactive}>
            <FiCamera size={20} color="#8F90A6" />
          </div>
        ))}

      {!!percentualGeral &&
        (reportSelecionado === 'diagnosticos' ||
          reportSelecionado === 'atendimentosSse') && (
          <Tooltip
            classes={classesTooltip}
            placement="top-start"
            arrow
            title={
              <React.Fragment>
                <div className={styles.tooltip_wrapper}>
                  <h4>Resultados diagnósticos</h4>
                  <br></br>
                  <h4>{Math.ceil(percentualGeral)}</h4>
                  <h4> {classificacao ?? 'Sem classificação'} </h4>
                  <br></br>

                  {temas.map((tem) => (
                    <>
                      <h4>{tem.titulo}</h4>
                      <h4>{numberToPorcent(tem.percentual)}</h4>
                      <br></br>
                    </>
                  ))}
                </div>
              </React.Fragment>
            }
          >
            <span>
              <BaSeIcon
                name="file-edit-alt"
                size={23}
                description="Imagem de view"
                color="#00ccff"
              />
            </span>
          </Tooltip>
        )}
      {row?.empresas?.length > 0 && (
        <Tooltip
          classes={classesToolTipEmpresas}
          placement="top-start"
          arrow
          title={
            <React.Fragment>
              <div className={styles.tooltip_wrapper}>
                <h4>Empresas próprias</h4>
                <br></br>
                {row.empresas.map((empresa) => (
                  <h4>
                    {' '}
                    -{cnpjMask(empresa.cnpj)}:
                    {empresa?.nomeFantasia ?? empresa.razaoSocial}{' '}
                  </h4>
                ))}
              </div>
            </React.Fragment>
          }
        >
          <span>
            <BaSeIcon
              name="home-alt"
              size={23}
              description="Imagem de view"
              color="#00ccff"
            />
          </span>
        </Tooltip>
      )}
      {row.statusIntegracao !== 'CONCLUIDO' &&
      reportSelecionado === 'registroSas' ? (
        <Tooltip
          classes={classesTooltipErroSas}
          placement="left"
          arrow
          title={
            <React.Fragment>
              <div className={styles.tooltip_wrapper}>
                <p>{row.observacoesIntegracao}</p>
              </div>
            </React.Fragment>
          }
        >
          <span>
            <AiOutlineCloseCircle size={25} color="#FF0000" />
          </span>
        </Tooltip>
      ) : (
        reportSelecionado === 'registroSas' && (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.1556 0C5.6076 0 0.300049 5.35438 0.300049 11.9608C0.300049 18.5669 5.6076 23.9218 12.1556 23.9218C18.7029 23.9218 24.0112 18.5661 24.0112 11.9608C24.0112 5.35464 18.7029 0 12.1556 0V0ZM12.1556 22.4263C6.42645 22.4263 1.78216 17.7408 1.78216 11.9608C1.78216 6.18076 6.42645 1.49526 12.1556 1.49526C17.8848 1.49526 22.5291 6.18076 22.5291 11.9608C22.5291 17.7408 17.8848 22.4263 12.1556 22.4263V22.4263Z"
              fill="#33CC66"
            />
            <path
              d="M17.5653 7.76902L9.94185 15.3912L6.76964 12.2545C6.47795 11.9623 6.00368 11.9623 5.71173 12.2545C5.41901 12.547 5.41901 13.02 5.71173 13.3115L9.41597 16.9737C9.71974 17.2439 10.174 17.2734 10.4741 16.9737L18.6239 8.82622C18.9159 8.53479 18.9159 8.06072 18.6239 7.76902C18.3315 7.47759 17.858 7.47759 17.5653 7.76902V7.76902Z"
              fill="#33CC66"
            />
          </svg>
        )
      )}

      <Dialog
        fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          {/* <CarouselImg img={rowSelectedToImg} /> */}
          <SwiperImg img={rowSelectedToImg} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Fechar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
